import PersonService from "./PersonService";
import CompanyService from "./CompanyService";
import { ApiClient } from "@zoox-framework/zoox-infra";
import i18n from "@/middlewares/i18n";

export default class PaymentService {
  constructor() {
    const personService = new PersonService();
    this.companyService = new CompanyService();
    this.personId = personService.getPersonId();
    this.apiClient = new ApiClient();
  }

  async upsertSubscription(source, subscription) {
    return this.apiClient.post("open/payment/subscription", {
      source,
      subscription
    });
  }

  async generatePin(orderId, chargeId = null, phone = null) {
    const company = this.companyService.getCurrentCompany();
    return await this.apiClient.post("payment/generatePin", {
      orderId,
      chargeId,
      personId: this.personId,
      message: `${company.name} : ${i18n.t(
        "PAYMENT_SOLICITATION.GENERATE_PIN"
      )}`,
      phone
    });
  }

  async validatePin(orderId, pin, chargeId = null) {
    const resp = await this.apiClient.post("payment/validatePin", {
      orderId,
      chargeId,
      personId: this.personId,
      pin: Number(pin)
    });

    return resp.validated;
  }

  async getChargeByToken(chargeToken) {
    return this.apiClient.get(`payment/customerByChargeToken/${chargeToken}`);
  }

  async updatePersonCharge(personId, chargeToken) {
    return this.apiClient.put("payment/person/charge", {
      personId,
      chargeToken
    });
  }

  async pay(orderId, chargeId, personId, payments, isClosed = false) {
    return this.apiClient.post(
      "open/payment/pay",
      {
        orderId,
        chargeId,
        personId,
        isClosed,
        payments
      },
      null,
      false,
      true
    );
  }

  checkout(reservationNumber) {
    this.apiClient.post("hotel/checkout", { reservationNumber });
  }

  checkoutEmail(data) {
    this.apiClient.post("email/sendCheckoutEmail", data);
  }

  async updateCustomer(data) {
    return this.apiClient.put("open/payment/customer", data);
  }

  getStateById(id) {
    return this.apiClient.get(`open/state/${id}`);
  }

  async getCustomerByToken(token, companyId) {
    return this.apiClient.get(
      `token/customerWithoutAuth/${token}/${companyId}`
    );
  }
}
